import infoGreen from 'assets/images/account-page/info-green.svg';
import classNames from "classnames";
import React, { useRef, useEffect } from "react";
import { getBrandName } from 'utils/brand';
import css from "../style.scss";
import { useDispatch, useSelector } from 'react-redux';
import { selectPlanDetails, updateSelectedChooseTierTooltip } from '../../../../data/user';


const SaveAndExportsPopup = ({annualPlan}) => {
    const dispatch = useDispatch();
    const planDetails = useSelector(selectPlanDetails)?.toJS();
    const containerRef = useRef(null);
    const tooltipPrefix = annualPlan ? 'annualEssentials':'monthlyEssentials';
    
    const handleTooltipToggle = (tooltipId) => {
         if (!tooltipId) {
             dispatch(updateSelectedChooseTierTooltip(""));
             return;
         }
         const tooltipComponentId = `${tooltipPrefix}-${tooltipId}`;
         dispatch(updateSelectedChooseTierTooltip(tooltipComponentId));
     };

    useEffect(() => {
        return () => {
            dispatch(updateSelectedChooseTierTooltip(""));
        };
    }, []);

    return (
        <div className={css.clsSaveAndExportInfoPopup} ref={containerRef}>
            <div>
                Saves & Exports
                <span className={css.clsInfoIcon} onClick={() => handleTooltipToggle('saveAndExports')}>
                    <img src={infoGreen} alt="info" />
                    <div className={classNames(css.clsInfoPopupContent, css.clsInfoPopupBottom, css.saveAndExportsPopup, {
                        [css.clsOpenPopup]: planDetails?.selectedChooseTierTooltip === tooltipPrefix + '-saveAndExports',
                    })}>
                        <h6 className={css.clsInfoContentTitle}>Saves & Exports <span className={css.clsCloseIcon} onClick={(e) => { e.stopPropagation(); handleTooltipToggle(''); }}>&times;</span></h6>
                        <p className={css.clsInfoContentPara}><b>{getBrandName()}</b> makes it easy to save, export, and organize your real estate leads for effective marketing and outreach. Quickly export your leads to use with other tools and keep your records up to date. Additional saves and exports are available for purchase.
                        <br/><b><i>NOTE: Unused saves and exports don't roll over. Each month your account resets to your regular limit.</i></b></p>
                    </div>
                </span>
            </div>
        </div>
    );
};

export default SaveAndExportsPopup;